import { NoddiIcon } from 'noddi-ui-common';
import { NavioConfetti } from 'noddi-ui-web';
import { useRef } from 'react';
import { FleetSwapTranslations } from './fleetSwapTranslations';
import { FleetSwapCandidate, FleetSwapOutgoing } from './fleetSwapTypes';

type Props = {
  outgoing: FleetSwapOutgoing;
  incoming: FleetSwapCandidate;
  canceledBookingCount: number;
  translations: FleetSwapTranslations;
};

/** Final step of the swap: the same confetti + check the customer app shows on a confirmed order. */
export const FleetSwapSuccess = ({ outgoing, incoming, canceledBookingCount, translations: t }: Props) => {
  const animationRef = useRef<HTMLDivElement>(null);
  const outcomes = [
    t.noLongerOnSchedule(outgoing.licensePlateNumber),
    ...(incoming.isNewToFleet ? [t.addedToFleet(incoming.licensePlateNumber)] : []),
    ...(canceledBookingCount > 0 ? [t.canceledBookings(canceledBookingCount, outgoing.licensePlateNumber)] : [])
  ];

  return (
    <>
      <NavioConfetti triggerRef={animationRef} pieceCount={60} duration={3.5} />
      <div className='flex flex-col items-center gap-5 py-4 text-center'>
        <div ref={animationRef} className='flex items-center justify-center rounded-full bg-green-50 p-2'>
          <NoddiIcon name='CircleCheck' size='xLarge' className='fill-green-500 text-white' />
        </div>
        <h3 className='text-xl font-semibold'>
          {t.nowOnSchedule(incoming.licensePlateNumber, outgoing.fleetScheduleName)}
        </h3>
        <ul className='flex flex-col gap-1 text-sm text-muted-foreground'>
          {outcomes.map((outcome) => (
            <li key={outcome}>{outcome}</li>
          ))}
        </ul>
      </div>
    </>
  );
};
